export const GET_UNSUBSCRIBE_REASONS =
  'unsubscribe-reasons/GET_UNSUBSCRIBE_REASONS';

export const GET_UNSUBSCRIBE_REASONS_BY_STUDENT_ID =
  'unsubscribe-reasons/GET_UNSUBSCRIBE_REASONS_BY_STUDENT_ID';
